import React, { useEffect, lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { SpeedInsights } from "@vercel/speed-insights/react";
import { Analytics } from "@vercel/analytics/react"; // Import Analytics from Vercel}
import Navbar from "./components/Navbar";
import Home from "./pages/HomePage"; // eagerly loaded (critical)

const About = lazy(() => import("./pages/AboutPage"));
const Contact = lazy(() => import("./pages/ContactUs"));
const ProceduresOffered = lazy(() => import("./pages/ProceduresOffered"));
const Treatments = lazy(() => import("./pages/Treatments"));
const TreatmentsList = lazy(() => import("./pages/TreatmentList"));
const NotFound = lazy(() => import("./pages/NotFound"));

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <ScrollToTop />
        <main className="flex-grow">
          <Suspense fallback={<div className="flex justify-center items-center h-screen text-lg">Loading...</div>}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/procedures" element={<ProceduresOffered />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/treatments" element={<TreatmentsList />} />
              <Route path="/treatments/:slug" element={<Treatments />} />
              <Route path="/procedures/:slug" element={<ProceduresOffered />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </main>
        <SpeedInsights />
        <Analytics />
      </div>
    </Router>
  );
}

export default App;
